<template>
  <v-dialog
      v-model="dialog"
      width="500"
      hide-overlay
      transition="dialog-bottom-transition"
      style="overflow: hidden;"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          outlined
          dark
          v-bind="attrs"
          v-on="on"
        >
          {{ label }}
        </v-btn>
      </template>
      <v-card>
        <v-card-text>
          <v-form style="padding: 10px">
            <v-row class="mb-5 mt-5">
              <v-col cols="12">
                Pin:&nbsp;
                <PincodeInput
                  v-model="code"
                  placeholder="0"
                />
              </v-col>
            </v-row>
            <v-btn block color="success" @click="sign">Sign</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
      <!-- <v-card>
        <v-row>
          <v-col cols="4"
          v-for="item in [1, 2, 3, 4, 5, 6, 7, 8, 9, 0]" :key="item.id">
            <v-card elevation="4"
              style="height: 100px; width: 100px; padding: 40px; font-size: 30px"
            >
              {{ item }}
            </v-card>
          </v-col>
        </v-row>
      </v-card> -->
    </v-dialog>
</template>

<script>
import PincodeInput from 'vue-pincode-input';

export default {
  components: {
    PincodeInput,
  },
  props: ['label'],
  data() {
    return {
      dialog: false,
      code: '',
    };
  },
  methods: {
    sign() {
      this.$emit('sign', this.code);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
